import COLORS from '@/constants/colors';

export default {
  wrapper: {
    bgcolor: '#FFFFFF',
    border: `1px solid ${COLORS.gray_300}`,
    borderRadius: '10px',
    p: '16px',
  },
};
